"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StorytellingApproach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222529" id="responsivesplitcontent" className="bg-background text-foreground w-full overflow-hidden">
      <div className="flex flex-col md:flex-row w-full min-h-[600px]">
        <div ref={ref} className={`w-full md:w-[60%] flex flex-col justify-center px-6 py-20 md:py-24 md:pl-[10%] lg:pl-[15%] md:pr-12 lg:pr-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl font-default font-bold leading-tight mb-8 !text-[rgba(3,140,129,1)] md:text-[48px]">Schlanker, straffer, jünger Aussehen</h2>
          <p className="font-default text-muted-foreground leading-relaxed mb-10 !font-bold !text-lg">
            Sichtbare Ergebnisse, tiefste Entspannung.
            <div className="!text-lg">Gönn dir eine Auszeit mit dem BEWEI Vitalitätskonzept. Die sanfte Radiofrequenzbehandlung verschönert Körper und Gesicht – ganz ohne Umziehen. Unser ganzheitlicher Ansatz kombiniert moderne Technologie mit Tipps für Ernährung und Bewegung, um dich auf deinem Weg zum Wunsch-Körper zu begleiten. Erlebe die Methode, der Profis in führenden Spas und Loungen weltweit seit zwei Jahrzehnten vertrauen.</div>
          </p>
          <div>
            <Button variant="outline" size="lg" className="rounded-md border-primary text-primary hover:bg-accent hover:text-accent-foreground px-8 py-6 text-sm tracking-widest uppercase transition-all duration-300 shadow-md" asChild>
              
            </Button>
          </div>
        </div>

        <div className="w-full md:w-[40%] relative min-h-[400px] md:min-h-auto group overflow-hidden flex items-center justify-center">
          <img src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/Bodyconcept_linda_bewei-2.jpg" data-wvc-srcset="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/Bodyconcept_linda_bewei-2.jpg-wvc-srcset" data-wvc-sizes="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/Bodyconcept_linda_bewei-2.jpg-wvc-sizes" alt="Linda in ihrer modernen Beauty Lounge in Allendorf" className="absolute inset-0 m-auto w-[85%] object-cover rounded-lg transition-transform duration-700 group-hover:scale-105 shadow-xl !h-[600px]" loading="lazy" decoding="async" />
          <div className="absolute inset-0 bg-accent/10 pointer-events-none rounded-lg m-auto w-[85%] h-[85%]" />
        </div>
      </div>
    </section>;
}